import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

// services
import * as moment from 'moment';
// models
import { ReportPayload } from 'src/app/reports/models/report-payload';
import { ReportCategory } from 'src/app/reports/models/report-category';
import { ReportTableColumn } from 'src/app/reports/models/report-table';
import { BasicReportData } from 'src/app/reports/models/report-viewers';
import { ReportService } from 'src/app/reports/services/report.service';
import { ReportType } from 'src/app/reports/models/report-types';
import { ReportTableType, reportTableModeMap} from 'src/app/reports/models/report-table';

@Component({
  selector: 'app-report-basic',
  templateUrl: './report-basic.component.html',
  styleUrls: ['./report-basic.component.scss', './../../report-viewer.component.scss']
})
export class ReportBasicComponent implements OnInit, OnChanges {
  @Input() report! : ReportPayload;
  @Input() category! : ReportCategory;
  @Input() columns! : ReportTableColumn[];

  basicData? : BasicReportData;

  public tableType : ReportTableType = ReportTableType.VIRTUAL_SCROLL;

  public reportType = ReportType;

  constructor(
    private reportService: ReportService
  ) { }


  ngOnInit(): void {  
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['report']) {
      this.updateReport(); // o lo que necesites ejecutar
    }
  }

   // EVENTS 
  updateReport(){
    let reportType = this.report.reportDetails.reportType
    for (const [key, reports] of Object.entries(reportTableModeMap)) {
      if (reports.includes(reportType as ReportType)) {
        this.tableType = key as ReportTableType;
        break;
      }
    }
    this.formatReportTable();
  }

  // FUNCIONTS
  formatReportTable(){
    this.basicData = this.report.dataViewer;
  }

  public actualizarEvaluacionEventos() {
    var dataParams:any = this.report.systemParams;// this.reportService.getParams();

    dataParams['fecha_hasta2'] = dataParams['fecha_hasta'];
    dataParams['fecha_hasta'] = moment(new Date()).format("YYYY-MM-DD") + 'T' + moment(new Date()).format("HH:mm:ss") + '-05:00';

    this.report.systemParams = dataParams
    console.log("acutlizar evalucaion eventos", this.report)
    this.reportService.reloadReport(this.report)
  }

  public guardarEvaluacionEventos() {
    this.reportService.saveEvaluacionEventos(this.report, this.basicData?.records || [] )
  }

}
